import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ExitIframe() {
  const { search } = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const redirectUri = params.get("redirectUri");

    if (!redirectUri) {
      return;
    }

    try {
      const decodedRedirectUri = new URL(decodeURIComponent(redirectUri));
      console.log("Redirecting out of iframe:", decodedRedirectUri.toString());

      // Only allow iframe exits to Shopify Admin, the current app host, or a
      // myshopify domain so this route cannot become an open redirect.
      if (
        ["admin.shopify.com", window.location.hostname].includes(decodedRedirectUri.hostname) ||
        decodedRedirectUri.hostname.endsWith(".myshopify.com")
      ) {
        window.open(decodedRedirectUri.toString(), "_top");
      } else {
        console.log("Invalid redirect hostname:", decodedRedirectUri.hostname);
      }
    } catch (error) {
      console.log("Invalid redirect URL:", error);
    }
  }, [search]);

  return <div>Redirecting...</div>;
}
